import { useEffect } from "react";
import { api } from "./api.ts";

// My device's time zone, told to Tripmo when it differs from the one Tripmo has (features/tasks-and-reminders.md):
// due-date reminders and the weekly round-up go at 9:00 in it. Read on every open, so a phone that travels
// moves my 9:00 with it the next time Tripmo is opened.
export function deviceZone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

// Once signed in (`known`: the zone Tripmo has for me, null when none yet; undefined until I'm loaded).
export function useDeviceZone(known: string | null | undefined): void {
  useEffect(() => {
    if (known === undefined) return;
    const zone = deviceZone();
    // Not told again until it changes; a failure (offline) is told on the next open.
    if (zone && zone !== known) api.setTimeZone(zone).catch(() => {});
  }, [known]);
}
